import { createApp } from 'vue';
import TheUploadList from './TheUploadList';
import { satGlobals } from '../../../qaamgo/sat/helper/sat-globals';
import { globalLogger } from '../../../qaamgo/helper/global-logger';

let isInitialized = false;
function initFileUploadList() {
    return new Promise((resolve, reject) => {
        if (isInitialized) {
            resolve();

            return;
        }

        const isVueFileListEnabled = satGlobals.isVueUploaderFileListEnabled();

        if (!isVueFileListEnabled) {
            reject();

            return;
        }

        if (document.getElementById('vueUploadList') === null) {
            if (isVueFileListEnabled) {
                globalLogger.log('uploader file list - vue version is enabled but no root element found!');
            }

            reject();

            return;
        }

        isInitialized = true;

        import(
            /* webpackMode: "lazy-once" */
            `../../../entrypoints/translations/sat-translations.js`
        ).then(() => {
            createApp(TheUploadList).mount('#vueUploadList');


            globalLogger.log('uploader file list - created vue root instance');

            resolve();
        });
    });
}

export { initFileUploadList };
